export default "__VITE_PUBLIC_ASSET__5945505f__"